import PriceFormat from './PriceFormat';

export default PriceFormat;
